import makeStyles from '@material-ui/core/styles/makeStyles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 4,
    paddingTop: 8,
  },
  parameter: {
    color: theme.palette.text.secondary,
  },
  liquidationNotice: {
    color: theme.palette.text.secondary,
  },
  statusTitle: {
    fontWeight: 600,
  },
  reloadButton: {
    marginTop: 8,
  },
  separator: {
    color: theme.palette.text.secondary,
  },
  infoButton: {
    padding: 2,
  },
  infoIcon: {
    fontSize: 16,
  },
}))
